<template>
  <div>
    <table :height="this.windowSize.height - 8" :max-height="this.windowSize.height - 8" style="position: absolute;"
           width="100%">
      <tr height="48px" max-height="48px">

        <ContenidoBase :EstadoBtn="EstadoBtn"
                       :descripcion="'Imprime Reporte Auxiliar Cuentas por Cobrar.'" :titulo="'Reporte Auxiliar Cuentas por Cobrar'"
                       @MethodAnular="anular" @MethodEliminar="remove" @MethodGuardar="save"
                       @MethodImprimir="imprimirList"
                       @MethodNuevo="newwnuevo" @abrirBarraTablaDinamica="abrirTabla"/>
      </tr>

      <tr>
        <!-- BarraPrimaria --------------------------------------------------------------------------------->
        <td v-show="BarraTablaDinamicaAprir" :max-height="this.windowSize.height - 96" width="109">

          <div class="overflow-y-auto "
               v-bind:style="{ 'max-height': this.windowSize.height - 96 + 'px', 'max-width': '325px', 'width': '325px' }">

            <v-tooltip left>
              <template v-slot:activator="{ on }">
                <center>
                  <v-btn-toggle>
                    <v-btn color="yellow accent-4" small @click.prevent="actualiza_tb_ver">
                      <i class="fa fa-eye" style="font-size: 25px;"> </i> ver
                    </v-btn>
                    <v-btn color="deep-purple accent-2" dark small
                           @click.prevent="notifi('Seguro que desea nuevo', 'n')">
                      <i class="fa fa-print" style="font-size: 25px;"> </i>
                      Listado
                    </v-btn>
                  </v-btn-toggle>
                </center>
                <!-- <BarraBusqueda2
              :url="
                $hostname + $hName + '/services/tipocliente/findalltipoclientes'
              "
              :nombre="'Tipo de Clientes'"
              :headers="headers"
              :slotname="'item.descripcion'"
              :emitnombre="'emitReporteAuxiliarCxC'"
              :SeachNombre="'Búsqueda por descripcion '"
              :slotlist="slotlist"
            /> -->
              </template>
            </v-tooltip>

          </div>
        </td>
        <!-- fn BarraPrimaria ---------------------------------------------------------------------------------->
        <!-- contenido central ------------------------------------------------------------------------------ -->
        <td :max-height="this.windowSize.height - 96">
          <v-app id="inspire" class="overflow-y-auto "
                 v-bind:style="{ 'max-height': this.windowSize.height - 96 + 'px' }">

            <!-- Formulario-Auxiliar Cuentas por Cobrar -->
            <v-container>
              <v-card color="grey lighten-3">

                <v-toolbar color="#BDBDBD" dense flat style="border: 1px solid #000000;">


                  <v-avatar size="45" tile>
                    <img alt="Reporte" src="@/assets/iconos_micromarket/custom-reports.png">
                  </v-avatar>


                  <span class="font-weight-light" style="font-size: 20px;"> Reporte Auxiliar Cuentas por Cobrar </span>

                  <!-- <v-toolbar-title    class="font-weight-light"> Reporte Producción de boletos por unidades</v-toolbar-title > -->
                  <!-- style="color:white;" -->
                  <!-- <i class=""> </i> -->

                  <!-- <v-spacer></v-spacer> -->
                  <!-- <v-btn
          color="grey darken-4"
          fab
          small
          @click="cerrarmodalcuenta"
        >
         <i  style="font-size: 20px; color:white;" class="fa fa-close"></i>
        </v-btn> -->
                </v-toolbar>

                <hr>

                <v-container style="border: 1px solid #000000;">
                  <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="">
                    <v-row>
                      <!-- columna 1 -->
                      <v-col cols="12" md="6" sm="6">


                        <!-- -----------------------------  desde  -->
                        <v-text-field v-model="AuxiliarCxC.desde" :rules="[$rules.required]" dense label="Desde:" outlined
                                      type="date">
                          <template v-slot:prepend>
                            <i class="fa fa-calendar" style="font-size: 20px;"></i>
                          </template>

                        </v-text-field>

                        <!-- -----------------------------  Cliente  -->
                        <v-combobox v-model="AuxiliarCxC.cliente" :items="Rcliente" autocomplete="off" dense item-text="codnom"
                                    label="Cliente:" no-filter outlined
                                    @blur="SelctCbClient"
                                    @focus="cargarCliente" @keyup="CbFilcliente">
                          <template slot="item" slot-scope="item">
                            <span style="display:none;">{{
                                item.item.codnom = `${item.item.codigo} - ${item.item.nombre.trim()} `
                              }}</span>
                            <span
                                class="fontSize13"><b>{{ item.item.codigo }}</b> - {{ item.item.nombre.trim() }}</span>
                          </template>

                          <template v-slot:selection="{ attrs, item, parent, selected }">
                            <span class="fontSize13 colorNombre"><b>{{ item.codigo }}</b> - {{ item.nombre }}</span>
                          </template>
                          <template v-slot:prepend>
                            <i class="fa fa-user-circle-o" style="font-size: 30px;"></i>
                          </template>
                        </v-combobox>

                        <!-- ----------------------------- Documentos -->
                        <v-combobox
                            v-model="AuxiliarCxC.documento"
                            :items="RDocumento"
                            autocomplete="off"
                            clearable
                            dense
                            item-text="descripcionMostrar"
                            label="Documentos:"
                            outlined
                            @blur="SelctCbDocumento"
                            @focus="cargarDocumento"
                        >
                          <template v-slot:prepend>
                            <i class="fa fa-file-text-o" style="font-size: 20px;"></i>
                          </template>
                        </v-combobox>

                      </v-col>
                      <!-- fn columna 1 -->


                      <!-- columna 2 -->
                      <v-col cols="12" md="6" sm="6">

                        <!-- -----------------------------  Hasta  -->
                        <v-text-field v-model="AuxiliarCxC.hasta" :rules="[$rules.required]" dense label="Hasta:" outlined
                                      type="date">
                          <template v-slot:prepend>
                            <i class="fa fa-calendar" style="font-size: 20px;"></i>
                          </template>

                        </v-text-field>

                        <!-- ----------------------------- Tipo de Cliente -->
                        <v-combobox v-model="AuxiliarCxC.tipocliente" :items="RtipoCliente" autocomplete="off" dense item-text="descripcion"
                                    label="Tipo de Cliente:" outlined @blur="SelctCbTipoCliente"
                                    @focus="cargarTipoCliente">
                          <template v-slot:prepend>
                            <i class="fa fa-users" style="font-size: 20px;"></i>
                          </template>
                        </v-combobox>

                        <!--- Subtipo de Cliente --->
                        <v-autocomplete
                            v-model="AuxiliarCxC.subtipoCliente"
                            :items="AuxiliarCxC.tipocliente ? AuxiliarCxC.tipocliente.subtipos : AuxiliarCxC.subtipo || []"
                            clearable
                            dense
                            item-text="descripcion"
                            label="Subtipo"
                            outlined
                            return-object
                        >
                          <template v-slot:prepend>
                            <i class="fa fa-user-plus" style="font-size: 20px; width: 1.3rem"></i>
                          </template>
                        </v-autocomplete>

                      </v-col>
                      <!-- fn columna 2 -->

                    </v-row>

                  </v-form>
                </v-container>

                <hr>

                <ModalReporteFiltros2 :Datos="AuxiliarCxC" @DataReporteBasico="DDataReporteBasico"/>

              </v-card>
            </v-container>
            <!-- Formulario-Auxiliar Cuentas por Cobrar -->
          </v-app>
        </td>
        <!-- fn contenido central ------------------------------------------------------------------------------------->
        <!-- BarraSecundaria ------------------------------------------------------------------------------------------>
        <td v-show="BarraSecundariaAprir" :max-height="this.windowSize.height - 96" width="109">

          <div class="overflow-y-auto "
               v-bind:style="{ 'max-height': this.windowSize.height - 96 + 'px', 'max-width': '325px', 'width': '325px' }">

            <!--         
        <BarraBusqueda2
              :url="$hostname + $hName + '/services/caja/findAll'"
              :nombre="'Cajas'"
              :headers="headers"
              :slotname="'item.descripcion'"
              :emitnombre="'emitCaja'"
              :slotlist="slotlist"
              :SeachNombre="'Búsqueda por descripción caja'"
            /> -->
          </div>

        </td>
        <!-- fn BarraSecundaria --------------------------------------------------------------------------------------->


      </tr>
    </table>
    <!-- Modales -------------------------------------------------------------------------------------------------->
    <!-- ------------------------------------------------------ tb-data-->
    <v-dialog v-model="acti_tb_data" label="myAlert" max-height="100%" max-width="100%" persistent
              transition="fab-transition">
      <v-card>
        <v-toolbar color="#BDBDBD" flat>
          <i class="fa fa-file-pdf-o" style="font-size: 20px;"></i>
          <v-toolbar-title class="font-weight-light"> REPORTE</v-toolbar-title>
          <i class="fa fa-file-pdf-o" style="font-size: 20px;"> </i>

          <v-spacer></v-spacer>
          <v-btn color="grey darken-4" fab small @click="acti_tb_data = !acti_tb_data">
            <i class="fa fa-close" style="font-size: 20px; color:#dd4b39;"></i>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-card>
            <v-card-title>
              <v-text-field v-model="search" hide-details label="Buscar" single-line @keyup="filtro">
                <template v-slot:prepend-inner>
                  <i class="fa fa-search" style="font-size: 35px;"></i>
                </template>
              </v-text-field>
            </v-card-title>

            <v-data-table :headers="slotHtabla" :items="list" :search="search" dense @click:row="datostabla">
              <template v-slot:item.porciento="props">
                <span>{{ currencyFormatter(props.item.porciento) }}</span>
              </template>
            </v-data-table>
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>


    <!------------otras funciones---------------->
    <v-snackbar v-model="aalert.estado" :color="aalert.color" :timeout="120000" :vertical="true"
                style="margin-top: 20%;" top="top">
      {{ aalert.nombre }}
      <v-btn dark text @click="aalert.estado = false">Close</v-btn>
    </v-snackbar>

    <!-- fn Modales ----------------------------------------------------------------------------------------------->


  </div>
</template>

<script>
import {EventBus} from "../../event-bus";
import BarraBusqueda2 from "../../components/BarraBusquedaDinam";
import ContenidoBase from "../../components/ContenidoBase";
import ModalReporteFiltros2 from "../../components/ModalReporteFiltros2";
import {
  currencyFormatter,
  fechaNueva,
  FormatoFecha,
  getParamFecha,
  HoraFormatter,
  HoraFormatter2,
  RedondeoBasico,
  RedondeoValor,
  RedondeoValorCantRed
} from "@/js/Funciones.js";

export default {
  components: {
    BarraBusqueda2,
    ContenidoBase,
    ModalReporteFiltros2
  },
  created() {
    var json = {
      titulo: "Reporte Auxiliar Cuentas por Cobrar",
      descripcion: "Imprime Reporte Auxiliar Cuentas por Cobrar.",
      save: false,
      eliminar: false,
      anular: false,
      nuevo: false,
      imprimir: false,
      accion: [

        "ReporteAuxiliarCxCNew",
        "ReporteAuxiliarCxCSave",
        "ReporteAuxiliarCxCRemove",
        "ReporteAuxiliarCxCAnular",
        "ReporteAuxiliarCxCPrintList"
      ],
    };
    EventBus.$emit("anularBotonesAccion", json);
  },
  mounted() {
    EventBus.$on("abrirMenuizquierdo", this.abrirTabla);
    // EventBus.$on("abrirMenuizquierdo", this.abrirTabla2);
    EventBus.$on("ReporteAuxiliarCxCNew", this.new);
    EventBus.$on("ReporteAuxiliarCxCSave", this.save);
    EventBus.$on("ReporteAuxiliarCxCRemove", this.remove);
    EventBus.$on("ReporteAuxiliarCxCAnular", this.remove);
    EventBus.$on("ReporteAuxiliarCxCPrintList", this.imprimirList);
    EventBus.$on("emitReporteAuxiliarCxC", this.datostabla);
    this.cargarTodo();

    EventBus.$on("onResize", this.onResize);
  },

  data: () => ({

    Rpropietario: [],
    RCaja: [],
    RtipoCliente: [],
    Rcliente: [],
    RDocumento: [],
    ListaTiposClientes: [],
    windowSize: {width: "auto", height: "auto"},
    AuxiliarCxC: {
      nombre: 'Auxiliar Cuentas por Cobrar',
      UrlImprimir: '/reportescxc/ImprimirAuxiliarCuentas',
      UrlExel: '/reportescxc/ExcelAuxiliarCuentas',
      UrlCorreo: '/reportescxc/CorreoAuxiliarCuentas',
      desde: fechaNueva(),
      hasta: fechaNueva(),
      tipocliente: null,
      subtipoCliente: null,
      cliente: null,
      documento: null
    },

    EstadoBtn: {
      BarraTablaDinamicaAprir: false,
      nuevo: false,
      guardar: false,
      eliminar: false,
      anular: false,
      imprimir: false,
      vercuenta: false,
      guardartemporal: false,
      restaurartemporal: false,
      importarDato: false,
      cargarProducto: false,
      ImprimirproductoInv: false,
    },


    text: "",
    valid: true,
    BarraTablaDinamicaAprir: false,
    BarraSecundariaAprir: false,

    headers: [{text: "Tipo Clientes", value: "descripcion"}],

    slotlist: [
      {dt0: "codigo", dt1: null, dt2: null, dt3: 1, dt4: "Código:"},
      {
        dt0: "descripcion",
        dt1: null,
        dt2: null,
        dt3: 1,
        dt4: "Descripcion:"
      },
      {dt0: "activo", dt1: null, dt2: null, dt3: 0.1, dt4: "Desactivo"},
    ],

    slotHtabla: [
      {text: "Código", value: "codigo"},
      {text: "Descripcion", value: "descripcion"}
    ],

    list: [],
    search: "",
    acti_tb_data: false,


    aalert: {
      estado: false,
      color: null
    },

  }),


  //   destroyed() {
  //     location.reload();
  //   },
  methods: {
    currencyFormatter,
    FormatoFecha,
    HoraFormatter,
    HoraFormatter2,
    RedondeoValor,
    RedondeoBasico,
    RedondeoValorCantRed,
    fechaNueva,
    getParamFecha,

    onResize(e) {

      console.log("imprii ")

      console.log(e)
      this.windowSize = e


    },

    abrirTabla() {
      this.BarraTablaDinamicaAprir = !this.BarraTablaDinamicaAprir;

    },
    async cargarTodo() {
      // await this.$axios
      //   .post(
      //     this.$hostname +
      //       this.$hName +
      //       "/services/tipocliente/findalltipoclientes",
      //     {
      //       usuario:JSON.parse(JSON.stringify(this.$user)) 
      //     }
      //   )
      //   .then(res => (this.ListaTiposClientes = res.data))
      //   .catch(error => console.log(error));
    },
    datostabla(e) {

      this.AuxiliarCxC = e;
      this.acti_tb_data = false
    },
    save() {

      if (this.$refs.form.validate()) {

        var jsn = {
          datos: JSON.parse(JSON.stringify(this.AuxiliarCxC)),
          usuario: JSON.parse(JSON.stringify(this.$user))
        }
        this.$axios
            .post(
                this.$hostname +
                this.$hName +
                "/services/tipocliente/saveTipoCliente",
                JSON.parse(JSON.stringify(jsn))
            )
            .then(res => this.alerta("Dato guardado correctamente!", "bien"))
            .catch(error =>
                this.alerta("Dato no guardado", "error"
                    // "hubo un error , por favor verifique el campo descripcion!",
                    // "error"
                )
            );
      } else {
        this.alerta("Los campos en rojo son requeridos", "error");
      }


    },
    remove() {
    },
    eliminar() {
    },
    anular() {
    },
    imprimirList() {
    },
    //Retorna los objectos del componente ModalReporteFiltros2 
    DDataReporteBasico() {
    },
    newwnuevo() {
      (this.AuxiliarCxC = {
        activo: true,
        borrado: false,
        codigo: 0,
        descripcion: "",
        descripcionOriginal: "",
        fechaCreacion: "",
        fechaModificacion: "",
        usuarioCreacion: "",
        usuarioModificacion: ""
      }),
          EventBus.$emit("actualizaBarraBusqueda2");
    },


    // Hacer una solicitud GET al servidor y devolver los datos al cliente.
    cargarCliente() {

      this.$axios.get(this.$hostname + this.$hName + '/clientes/findtodo/a/3/25/0', {headers: this.$store.getters.GetheadersAxios})
          .then(res => (this.Rcliente = res.data))

    },


    // Comprobando si el cliente es nulo o indefinido.
    SelctCbClient() {

      var _this = this;
      setTimeout(function () {
        if (_this.AuxiliarCxC.cliente == null) {
          _this.AuxiliarCxC.cliente = null;
          return;
        }

        if (!_this.AuxiliarCxC.cliente.hasOwnProperty('codigo')) {
          _this.AuxiliarCxC.cliente = "";
          _this.AuxiliarCxC.cliente = null;
          return;
        }


        /* if (_this.AuxiliarCxC.cliente.codigo == undefined) {
           _this.AuxiliarCxC.cliente = "";
           _this.AuxiliarCxC.cliente = null;
           return;
         }*/
      }, 300);

    },

    CbFilcliente(e) {
      //console.log(e.target.value)

      if (e.target.value.length >= 0) {

        this.$axios
            .get(
                this.$hostname +
                this.$hName +
                "/clientes/findtodo/" +
                (e.target.value === null || e.target.value.length == 0 ? 'A' : e.target.value) +
                "/3/25/0",
                {headers: this.$store.getters.GetheadersAxios}
            )
            .then(res => (this.Rcliente = res.data));
      }
    },


    // Llamar a la API y obtener los datos de la API.
    cargarTipoCliente() {

      this.$axios.get(this.$hostname + this.$hName + '/tipoclientes/findall', {headers: this.$store.getters.GetheadersAxios})
          .then(res => (this.RtipoCliente = res.data))

    },


    // Comprobando si el valor de la selección es nulo o indefinido.
    SelctCbTipoCliente() {

      if (this.AuxiliarCxC.tipocliente == null) {

        this.AuxiliarCxC.tipocliente = ''
      }

      if (this.AuxiliarCxC.tipocliente.codigo == undefined) {
        //this.alerta("Seleccione un tipo de cliente", "error");
        this.AuxiliarCxC.tipocliente = ''
        return
      }

    },

    SelctCbDocumento() {
      if (this.AuxiliarCxC.documento == null || this.AuxiliarCxC.documento === '') {
        this.AuxiliarCxC.documento = null
        return
      }
      if (this.AuxiliarCxC.documento.codigo == undefined) {
        this.alerta("Seleccione un documento", "error")
        this.AuxiliarCxC.documento = null
      }
    },

    cargarDocumento() {
      var headers = this.$store.getters.GetheadersAxios
      Promise.all([
        this.$axios.get(this.$hostname + this.$hName + "/documentoventas/findallActivos", { headers: headers }),
        this.$axios.get(this.$hostname + this.$hName + "/documentocxc/findallactivo", { headers: headers }),
      ]).then((res) => {
        var docsVenta = (res[0].data || []).map((d) => {
          return Object.assign({}, d, {
            origen: "FV",
            descripcionMostrar: (d.descripcion || "").toString().trim() + " (Venta)",
          })
        })
        var docsCxc = (res[1].data || []).map((d) => {
          return Object.assign({}, d, {
            origen: "CXC",
            descripcionMostrar: (d.descripcion || "").toString().trim() + " (CxC)",
          })
        })
        this.RDocumento = docsVenta.concat(docsCxc)
      }).catch((error) => console.log(error))
    },

    alerta(e, l) {
      if (l == "bien") {
        (this.aalert.estado = true),
            (this.aalert.color = "success"),
            (this.aalert.nombre = e);

        this.newwnuevo();
      }

      if (l == "error") {
        (this.aalert.estado = true),
            (this.aalert.color = "error"),
            (this.aalert.nombre = e);

        this.ejecucion = false;
      }
    },


    actualiza_tb_ver() {
      this.acti_tb_data = !this.acti_tb_data;
      this.filtro();
    },

    async filtro() {
    }
  }
};
</script>

<style>
</style>
